import axios from 'axios';

const url = '/api/v1/external/analytics';
            

class AnalyticsService {

static getCloudWords(ownerId, filter, token) {
        
    return new Promise(async (resolve, reject) => {

        //////console.log('AnalyticsService.getCloudWords(ownerId, filter, token)')
        
        if((typeof ownerId == 'undefined') || (ownerId === null)) {
        
            reject("Owner Id must be supplied.")
            
    
        } else if((typeof filter == 'undefined') || (filter === null)) {
        
            reject("Filter must be supplied.")
            
    
        } else {

            if(filter.completed == 'A' || filter.completed == 'All') {
                delete filter.completed
            }
            
            if(filter.folder === null || filter.folder == 'A' || filter.folder == 'All') {
                delete filter.folder
            }

            if(filter.context === null || filter.context == 'A' || filter.context == 'All') {
                delete filter.context
            }
    
            let resp = await axios.get(url + "/wordCloud/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
                headers: {Authorization: `Bearer ${token}`}
            })
            //////console.log('Hello, is it me you\'re looking for?')
            //////console.log("Resp = " + JSON.stringify(resp.data.counts));

            resolve(resp.data.counts)
        }

    })

    

}

static getDashboardData(ownerId, filter, token) {
    
    ////console.log('AnalyticsService.getDashboardData')

    return axios.get(url + "/dashboard/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
        headers: {Authorization: `Bearer ${token}`}
    })
}

static getDashboardAT(ownerId, filter, token) {
    
    ////console.log('AnalyticsService.getDashboardAT')

    return axios.get(url + "/dashboard/at/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
        headers: {Authorization: `Bearer ${token}`}
    })
}

static getDashboardContexts(ownerId, filter, token) {
    
    ////console.log('AnalyticsService.getDashboardContexts')

    return axios.get(url + "/dashboard/contexts/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
        headers: {Authorization: `Bearer ${token}`}
    })
}

static getDashboardFolders(ownerId, filter, token) {
    
    ////console.log('AnalyticsService.getDashboardFolders')

    return axios.get(url + "/dashboard/folders/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
        headers: {Authorization: `Bearer ${token}`}
    })
}

static getDashboardMTD(ownerId, filter, token) {
    
    ////console.log('AnalyticsService.getDashboardMTD')

    return axios.get(url + "/dashboard/mtd/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
        headers: {Authorization: `Bearer ${token}`}
    })
}

static getDashboardPS(ownerId, filter, token) {
    
    ////console.log('AnalyticsService.getDashboardPS')

    return axios.get(url + "/dashboard/ps/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
        headers: {Authorization: `Bearer ${token}`}
    })
}

static getDashboardThisWeek(ownerId, filter, token) {
    
    ////console.log('AnalyticsService.getDashboardThisWeek')

    return axios.get(url + "/dashboard/thisweek/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
        headers: {Authorization: `Bearer ${token}`}
    })
}

static getDashboardYTD(ownerId, filter, token) {
    
    ////console.log('AnalyticsService.getDashboardMTD')

    return axios.get(url + "/dashboard/ytd/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
        headers: {Authorization: `Bearer ${token}`}
    })
}

// 20260206 -- Copilot (Claude Sonnet 4.5) -- Added velocity API call with filter support
static getDashboardVelocity(ownerId, days, filter, token) {
    return axios.get(url + "/dashboard/velocity/" + ownerId + "/" + days, {
        headers: {Authorization: `Bearer ${token}`},
        params: filter
    })
}



}

export default AnalyticsService; 